export const meterReadingArr = (data) => [
  { value: data.generalReading, name: 'Общее' },
  { value: data.dayReading, name: 'Электричество День' },
  { value: data.nightReading, name: 'Электричество Ночь' },
];

export const getFacilityTarrif = (facilityTariffs, meterReading) => {
  return facilityTariffs.length > 1
    ? facilityTariffs.find(
        (facilityTariff) => facilityTariff.tariff.name === meterReading.name
      )
    : facilityTariffs[0];
};

export const getMeterReadings = (data, facilityTariffs) =>
  meterReadingArr(data)
    .filter((item) => !!item.value)
    .map((item) => {
      const facilityTariff = getFacilityTarrif(facilityTariffs, item);
      return {
        value: item.value,
        tariff: { id: facilityTariff?.tariff.id },
      };
    });

export const getOptions = (message) => {
  return {
    rules: [
      {
        required: true,
        message,
      },
    ],
  };
};
